import { AgentDatasetSchema } from "@redotech/redo-model/agents/agent-dataset";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateAgentDataset = {
  name: "updateAgentDataset" as const,
  input: z.object({
    _id: zExt.objectId(),
    name: z.string().optional(),
    description: z.string().optional(),
  }),
  output: AgentDatasetSchema,
};
